import { render, staticRenderFns } from "./AuthSubmitForm.vue?vue&type=template&id=d496d0f2&"
import script from "./AuthSubmitForm.vue?vue&type=script&lang=js&"
export * from "./AuthSubmitForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthSubmitForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports